module.exports = __webpack_public_path__ + "img/SBBGif.8be6839c.gif";